import "App.css";

function Faqs() {
  return (
    <>
      <div className="container rtl">
        <div className="row">
          <div className="col-md-12 sidebar_heading text-center mb-2">
            <h1 className="h3  mb-0 folot-left headerTitle">
              Frequently asked question
            </h1>
          </div>
        </div>
        <hr />
      </div>

      <div className="container pb-5 mb-2 mb-md-4 mt-3 rtl">
        <div className="row">
          <div className="col-lg-2" />
          <section className="col-lg-10 mt-3">
            <section className="container pt-4 pb-5 ">
              <div className="row pt-4">
                <div className="col-sm-6">
                  <ul className="list-unstyled">
                    <div id="accordion">
                      <div className="row mb-0" style={{ color: "black" }}>
                        <div className="col-1 mt-3">
                          <i className="czi-book text-muted mr-2" />
                        </div>
                        <div className="col-11">
                          <button
                            className="btnF btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo8"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                            style={{ textAlign: "left" }}
                          >
                            <li className="d-flex align-items-center border-bottom pb-3 mb-3">
                              How do I remove an item from my shopping cart?
                            </li>
                          </button>
                        </div>
                      </div>
                      <div
                        id="collapseTwo8"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordion"
                        style={{}}
                      >
                        <div className="card-body">
                          To remove an item from your shopping cart, please
                          follow these steps: Desktop: Step 1 - Go to your
                          “Cart”. Step 2 - Click on the “Bin” button to delete
                          your item from your cart or you can add to your
                          "Wishlist".
                        </div>
                      </div>
                    </div>
                    <div id="accordion">
                      <div className="row mb-0" style={{ color: "black" }}>
                        <div className="col-1 mt-3">
                          <i className="czi-book text-muted mr-2" />
                        </div>
                        <div className="col-11">
                          <button
                            className="btnF btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo7"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                            style={{ textAlign: "left" }}
                          >
                            <li className="d-flex align-items-center border-bottom pb-3 mb-3">
                              Why am I having trouble placing products in the
                              cart?
                            </li>
                          </button>
                        </div>
                      </div>
                      <div
                        id="collapseTwo7"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordion"
                        style={{}}
                      >
                        <div className="card-body">
                          If you are having trouble placing products in your
                          cart, the reasons could be - The selected color/size
                          is not available to purchase The item is not available
                          in stock right now.
                        </div>
                      </div>
                    </div>
                    <div id="accordion">
                      <div className="row mb-0" style={{ color: "black" }}>
                        <div className="col-1 mt-3">
                          <i className="czi-book text-muted mr-2" />
                        </div>
                        <div className="col-11">
                          <button
                            className="btnF btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo6"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                            style={{ textAlign: "left" }}
                          >
                            <li className="d-flex align-items-center border-bottom pb-3 mb-3">
                              How do I know if a product comes with free
                              installation?
                            </li>
                          </button>
                        </div>
                      </div>
                      <div
                        id="collapseTwo6"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          Free installation is offered for selected products
                          only. Be sure to check the product description of
                          products to get more details about installation.
                        </div>
                      </div>
                    </div>
                    <div id="accordion">
                      <div className="row mb-0" style={{ color: "black" }}>
                        <div className="col-1 mt-3">
                          <i className="czi-book text-muted mr-2" />
                        </div>
                        <div className="col-11">
                          <button
                            className="btnF btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo5"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                            style={{ textAlign: "left" }}
                          >
                            <li className="d-flex align-items-center border-bottom pb-3 mb-3">
                              Why do I see different prices for the same
                              product?
                            </li>
                          </button>
                        </div>
                      </div>
                      <div
                        id="collapseTwo5"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          Zambet is a marketplace. We have a huge seller base
                          and each one sources their product differently due to
                          which prices vary for the same product but you can
                          choose depending on your preference as the product
                          quality remains the same.
                        </div>
                      </div>
                    </div>
                  </ul>
                </div>
                <div className="col-sm-6">
                  <ul className="list-unstyled">
                    <div id="accordion">
                      <div className="row mb-0" style={{ color: "black" }}>
                        <div className="col-1 mt-3">
                          <i className="czi-book text-muted mr-2" />
                        </div>
                        <div className="col-11">
                          <button
                            className="btnF btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo4"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                            style={{ textAlign: "left" }}
                          >
                            <li className="d-flex align-items-center border-bottom pb-3 mb-3">
                              What is the overseas products return policy?
                            </li>
                          </button>
                        </div>
                      </div>
                      <div
                        id="collapseTwo4"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordion"
                        style={{}}
                      >
                        <div className="card-body">
                          The following return policy applies to overseas
                          products and supersedes all other terms and conditions
                          of sales on Zambet and the Zambet Return Policy:
                          Returns for overseas products are only accepted for
                          the reasons listed below: Item is defective or damaged
                          upon delivery. Item is not according to the seller’s
                          specifications mentioned on the website. Item is
                          wrong: the item delivered is not the item you ordered.
                          Note: Returns for overseas products on any other basis
                          will not be accepted.
                        </div>
                      </div>
                    </div>
                    <div id="accordion">
                      <div className="row mb-0" style={{ color: "black" }}>
                        <div className="col-1 mt-3">
                          <i className="czi-book text-muted mr-2" />
                        </div>
                        <div className="col-11">
                          <button
                            className="btnF btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo3"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                            style={{ textAlign: "left" }}
                          >
                            <li className="d-flex align-items-center border-bottom pb-3 mb-3">
                              How do I know if my product has a warranty?
                            </li>
                          </button>
                        </div>
                      </div>
                      <div
                        id="collapseTwo3"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          If a warranty is offered on a product, the warranty
                          period will be displayed on the product page, to the
                          right of the product image below “Delivery”. If a
                          product is sold by multiple vendors, the warranty
                          period offered by each vendor will be displayed to the
                          right of the page. Just click on the more information
                          icon on the right side of the Return and Warranty tab
                          to find the detailed warranty information.
                        </div>
                      </div>
                    </div>
                    <div id="accordion">
                      <div className="row mb-0" style={{ color: "black" }}>
                        <div className="col-1 mt-3">
                          <i className="czi-book text-muted mr-2" />
                        </div>
                        <div className="col-11">
                          <button
                            className="btnF btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo2"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                            style={{ textAlign: "left" }}
                          >
                            <li className="d-flex align-items-center border-bottom pb-3 mb-3">
                              What are the exciting campaigns on Zambet?
                            </li>
                          </button>
                        </div>
                      </div>
                      <div
                        id="collapseTwo2"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          Valentines Day Campaign. FataFati Friday Campaign.
                          12.12” Campaign. Happy New Year Campaign.
                        </div>
                      </div>
                    </div>
                    <div id="accordion">
                      <div className="row mb-0" style={{ color: "black" }}>
                        <div className="col-1 mt-3">
                          <i className="czi-book text-muted mr-2" />
                        </div>
                        <div className="col-11">
                          <button
                            className="btnF btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo1"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                            style={{ textAlign: "left" }}
                          >
                            <li className="d-flex align-items-center border-bottom pb-3 mb-3">
                              What kind of questions can I ask on IM?
                            </li>
                          </button>
                        </div>
                      </div>
                      <div
                        id="collapseTwo1"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          Do’s Asking product-based queries Asking queries
                          pertaining to product’s warranty, installation, etc.
                          Dont's Sharing contact details Using indecent,
                          impolite language Asking irrelevant queries Using IM
                          for lodging complaints.
                        </div>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </section>
          </section>
        </div>
      </div>

      <a className="btn-scroll-top show" href="#top" data-scroll>
        <span className="btn-scroll-top-tooltip text-muted font-size-sm mr-2">
          Top
        </span>
        <i className="btn-scroll-top-icon czi-arrow-up"> </i>
      </a>
    </>
  );
}

export default Faqs;
